<template>
      <div class="test pad-15">
        <timeline ></timeline>
        <TableSearch :searchConfig="searchConfig" :searchParams="searchParams" @resetCallBack="reset" @search="search"></TableSearch>
        <powerTable :width="'100%'"
               :tableLoading="tableLoading"
               :tabelButtons="tabelButtons"
               :templateData="tableTemplateData"
               :tableConfig="tableConfig"
               :pagination="pagination">
              <el-button type="primary" @click="dialogVisible2=true">聊天</el-button>
        </powerTable>
        <el-dialog  :close-on-click-modal="false" :close-on-press-escape="false" title="提示" :visible.sync="dialogVisible"  width="50%"  :before-close="handleClose">
          <div class="">
            <editForm ref="editForm" :width=width :formConfig="formConfig" :ruleForm="ruleForm" :rules="rules" :buttonConfig="buttonConfig"></editForm>
          </div>
        </el-dialog>
        <el-dialog  :close-on-click-modal="false" :close-on-press-escape="false" title="IM聊天调试"   :visible.sync="dialogVisible2"  width="50%"   :before-close="handleClose2">
              <div class="">
                  <webSrom ></webSrom>
              </div>
        </el-dialog>

      </div>
</template>

<script>
     import TableSearch from '../../../../components/tabel-search/tabel-search'
     import powerTable from '../../../../components/table/table'
     import editForm from '../../../../components/edit-form/edit-form'
     import publicApi from '../../../../api-path/public-api'
     import webSrom from "../../../../components/webSock/webSrom";
     import timeline from "../../../../components/timeline/timeline";
    export default {
        components: {
          powerTable,
          TableSearch,
          editForm,
          webSrom,timeline
        },
        name: "index",
        data(){
          return {

            dialogVisible2:false,
            dialogVisible:false,
            width:'100%',
            tableLoading:false,
            /*--------search-------*/
            searchParams:{
              name:'',//名称
              releaseTime:[],//时间
              treeSelect0:[],
              treeSelect2:null,
              page: 1,
              size: 10,
            },
            searchConfig:{
              dataName:'searchParams',
              items:[
                {
                  key: 'name',
                  placeholder:'请输入名称'
                },
                {
                  key: 'releaseTime',
                  valueType: 'daterange',
                  placeholder: '开始时间:结束时间',
                },
                {
                  key: 'treeSelect0',
                  valueType:'treeSelect',
                  options: [{
                    id: 'company',
                    label: 'Company',
                    children: [ {
                      id: 'team-i',
                      label: 'Team I',
                      children: [ {
                        id: 'person-a',
                        label: 'Person A',
                      }, {
                        id: 'person-b',
                        label: 'Person B',
                      } ],
                    }, {
                      id: 'team-ii',
                      label: 'Team II ',
                      children: [ {
                        id: 'person-c',
                        label: 'Person C',
                      }, {
                        id: 'person-d',
                        label: 'Person D',
                      } ],
                    }, {
                      id: 'person-e',
                      label: 'Person E',
                    } ],
                  }],
                  multiple:true,
                  limit:3,
                  height:300,
                  placeholder: '请选择你要选的地区1',
                },
                {
                  key: 'treeSelect2',
                  valueType: 'treeSelect',
                  options: [{
                    id: 'company',
                    label: 'Company',
                    children: [ {
                      id: 'team-i',
                      label: 'Team I',
                      children: [ {
                        id: 'person-a',
                        label: 'Person A',
                      }, {
                        id: 'person-b',
                        label: 'Person B',
                      } ],
                    }, {
                      id: 'team-ii',
                      label: 'Team II',
                      children: [ {
                        id: 'person-c',
                        label: 'Person C',
                      }, {
                        id: 'person-d',
                        label: 'Person D',
                      } ],
                    }, {
                      id: 'person-e',
                      label: 'Person E',
                    } ],
                  } ],
                  placeholder: '请选择你要选的地区2',
                },

              ]
            },
            /*------tabel--------*/
            tableTemplateData: [],     // 渲染数据
            tableConfig: {
              checkbox: true,
              checkboxFn:(data)=>{
                this.checkboxFn(data)
              },
              index: true,
              rows: [
                {
                  label: '名称',
                  prop: 'name',
                },{
                  label: '值',
                  prop: 'mum',
                },{
                  label: '时间',
                  prop: 'shareTime',
                },
                {
                  label: '评分',
                  prop: 'rateName',
                  type:'rate',
                },
                {
                  label: '是否开通',
                  type:'button',
                  text:'不开通',
                  activeText:'开通',
                  prop: 'isOpen',
                },
                {
                  label: '是否上报',
                  type:'button',
                  text:'不上报',
                  activeText:'上报',
                  prop: 'isReport',
                },
                {
                  label: '备注',
                  type:'popover',
                  prop: 'content',
                },

              ],
              //表格操作
              rowButtons: {
                width:'300',
                items:[
                  {
                    label: '编辑',
                    fn: (data)=> {
                      this.dialogVisible=true;
                      console.log(data)
                    },
                  },
                  {
                    label: '删除',
                    fn: (data)=> {
                      console.log(data)
                    },
                  },
                  // {
                  //   label: '查看',
                  //   size:14,
                  //   icon:'iconchakan1',
                  //   fn: (data)=> {
                  //     console.log(data)
                  //   },
                  // },
                  // {
                  //   label: '修改',
                  //   size:14,
                  //   icon:'iconxiugai',
                  //   fn: (data)=> {
                  //     console.log(data)
                  //   },
                  // },
                  // {
                  //   label: '删除',
                  //   size:14,
                  //   icon:'iconshanchu',
                  //   fn: (data)=> {
                  //     console.log(data)
                  //   },
                  // },
                ],
              },
            },
            pagination: {
              show: true,
              sizeChange: this.sizeChange,
              pageChange: this.pageChange,
            }, // 分页
            tabelButtons:[], // tabel按钮
            tableData: [ ], // 原始数据

            ruleForm:{
              antiqueName:'',//名字
              decade:'',//年度
              level:[],//类别
              pictureList:[],
              birthday:'',
              description:'',
              textContent:'',
              resourceId:''
            },
            rules:{
              antiqueName:[{ required: true, message: '请输入传承人', trigger: 'blur' } ],
            },
            buttonConfig: {
              validateAll: ['editForm'],
              buttons: [
                {
                  type: 'save',  // 保存
                  fn: (data) => { console.log(data)  },
                }, {
                  type: 'back', // 返回
                  fn: () => { console.log('点击返回了')}
                },
              ]
            },
            formConfig: {
              disabled: false,
              items: [
                [
                  {
                    valueType: 'input', // 类型
                    label: '名称',
                    key: 'name', // 数据名称
                    prop: 'name', // 验证规则
                    labelWidth: "140px",  // label 宽度
                    itemWidth: '50%',
                    maxlength:50,
                    placeholder: '请输入名称', // 提示信息
                   },
                  {
                    valueType: 'radio', // 类型
                    label: '性别',
                    key: 'sex', // 数据名称
                    prop: 'sex', // 验证规则
                    labelWidth: "140px",  // label 宽度
                    itemWidth: '50%',
                    data: [ {  name: '男',id: '男' }, { name: '女', id: '女'}, ],
                    options: {
                      label: 'name', value: 'id' },
                  },
                ],
                [

                  {
                    valueType: 'inputMap', // 类型
                    label: '选择地址',
                    key: 'birthday', // 数据名称
                    prop: 'birthday', // 验证规则
                    labelWidth: "140px",  // label 宽度
                    itemWidth: '50%',
                    placeholder: '请选择公布时间', // 提示信息
                  },
                  {
                    valueType: 'nautica', // 类型
                    label: '经纬度',
                    key: 'nation', // 数据名称
                    prop: 'nation', // 验证规则
                    labelWidth: "140px",  // label 宽度
                    itemWidth: '50%',
                    maxlength:30,
                    placeholder: '请输入经纬度', // 提示信息
                  },
                ],
                [
                  {
                    valueType: 'rate', // 类型
                    label: '评分',
                    key: 'rate', // 数据名称
                    prop: 'rate', // 验证规则
                    labelWidth: "140px",  // label 宽度
                    itemWidth: '50%',
                    placeholder: '请评分', // 提示信息
                  },
                  {
                    valueType: 'month', // 类型
                    label: '出生日期',
                    key: 'birthday', // 数据名称
                    prop: 'birthday', // 验证规则
                    labelWidth: "140px",  // label 宽度
                    itemWidth: '50%',
                    placeholder: '请选择公布时间', // 提示信息
                  },

                ],
                [
                  {
                    valueType: 'upload', // 类型
                    label: '头像照片',
                    key: 'pictureList', // 数据名称
                    prop: 'pictureList',
                    itemWidth: '50%',
                    disabled: false,
                    otherConfig: {
                      showInfoInput: false,
                      infoInputPlaceholder: '请输入图片文字说明',
                      imgWidth: '100px',
                      imgHeight: '80px',
                      method: ['delete', 'edit']
                    },
                    uploadConfig: {
                      accept: 'image/jpg,image/jpeg, image/png, image/tif, image/gif', uploadPath: publicApi.uploadFile,
                      size: '20480kb',  count: 1
                    },
                    options: {
                    	fileUrlKey: 'url',
                    	fileInfoKey: 'description',
                    },
                  },
                ],
                [
                  {
                    valueType: 'upload', // 类型
                    label: '图片上传',
                    key: 'pictureList', // 数据名称
                    prop: 'pictureList',
                    itemWidth: '100%',
                    disabled: false,
                    otherConfig: {
                      showInfoInput: false,
                      infoInputPlaceholder: '请输入图片文字说明',
                      imgWidth: '170px',
                      uploadHint: '注：支持jpg、png、tif、gif等格式且不超过20M，最多传3张',
                      imgHeight: '100px',
                      method: ['delete', 'edit']
                    },
                    uploadConfig: {
                      accept: 'image/jpg,image/jpeg, image/png, image/tif, image/gif', uploadPath: publicApi.uploadFile,
                      size: '20480kb',  count: 3
                    },
                    options: {
                      fileUrlKey: 'coverUrl',
                      fileInfoKey: 'description',
                    },
                  },
                ],
                [
                  {
                    valueType: 'ueditor', // 类型
                    itemWidth: '80%',
                    prop: 'textContent',
                    label: '个人介绍',
                    inputWidth: '100%',
                    labelWidth: "140px",
                    key: 'textContent',
                  }
                ],

              ]
            },

          }
        },
      created() {
        this.searchData();
      },
      methods:{
        searchData(){
          this.tableData=[
            {name:'这是个数据',mum:'值',btnName:'这是个按钮',isOpen:true ,isReport:false,content:'保险具有经济补偿、资金融通和社会管理功能，是市场经济条件下风险管理的基本手段，是金融体系和社会保障体系的重要组成部分，在社会主义和谐社会建设中具有重要作用。',rateName:2.5,shareTime:'2010-07-11 08:11:10'},
            {name:'这是个数据',mum:'值',btnName:'这是个按钮',isOpen:false,isReport:true,rateName:2.5,shareTime:'2010-07-11 08:11:10'},
            {name:'这是个数据',mum:'值',btnName:'这是个按钮',isOpen:true,isReport:true,rateName:3.5,shareTime:'2010-07-11 08:11:10'},
            {name:'这是个数据',mum:'值',btnName:'这是个按钮',isOpen:true,isReport:true,rateName:4.5,shareTime:'2010-07-11 08:11:10'},
            {name:'这是个数据',mum:'值',btnName:'这是个按钮',isOpen:true,isReport:false,rateName:5,shareTime:'2010-07-11 08:11:10'},
            {name:'这是个数据',mum:'值',btnName:'这是个按钮',isOpen:false,isReport:true,rateName:null,shareTime:'2010-07-11 08:11:10'}
          ];
          this.tableTemplateData=  this.tableData;
        },
        search(){ },
        reset(){
          this.searchParams={
            name:'',//名称
            releaseTime:[],//时间
            page: 1,
            size: 10,
          }
        },
        checkboxFn(data){
          console.log(data)
        },
        sizeChange(size){
          this.searchParams.size=size;
          // this.searchData(this.searchParams);
        },
        pageChange(page){
          this.searchParams.page=page;
          // this.searchData(this.searchParams);
        },
        handleClose(){
          this.dialogVisible=false;
        },
       handleClose2(){
              this.dialogVisible2=false;
       },

      }
    }
</script>

<style scoped>

</style>
